import request from '@/utils/request'
const BASE_URL = '/ViewLog'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  }, 
}